import FacilitiesLegendItem, { DISPLAY_OPTION_SIMPLE, DISPLAY_OPTION_PIN, DISPLAY_OPTION_DEFAULT, DISPLAY_OPTIONS } from './FacilitiesLegendItem';

export default FacilitiesLegendItem;
export { default as FacilitiesLegendItemLoading } from './FacilitiesLegendItemLoading';

export { DISPLAY_OPTION_SIMPLE, DISPLAY_OPTION_PIN, DISPLAY_OPTION_DEFAULT, DISPLAY_OPTIONS };
